/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { Snackbar, SnackbarContent } from '@mui/material';
import React from 'react';

/**
 * Based on eventShow.BannerComponent, but simpler.
 */
export const AccessRevokedBanner: React.FC<{
  open: boolean;
}> = ({ open }) => {
  return (
    <Snackbar
      css={snackbarStyles}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      open={open}
    >
      <SnackbarContent
        css={snackbarContentStyles}
        message="This user's account access is revoked"
      />
    </Snackbar>
  );
};

const snackbarStyles = css`
  margin-top: 50px;
`;

const snackbarContentStyles = css`
  background-color: #c3505d;
  border-radius: 4px;
  padding: 6px 16px;

  & .MuiSnackbarContent-message {
    display: flex;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    width: 100%;
    justify-content: center;
  }
`;
